import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as formReducer } from "redux-form";
import { persistReducer } from 'redux-persist';
import { reducer as toastrReducer } from "react-redux-toastr";
// import authThunk  from '../thunk/authThunk';
import { chart } from '../components/dashboard/reducer/index';

import { apiCalls } from "../api/reducers/index";
import { authReducer } from './authReducer';
import { signUp } from "../components/main/reducers/index";
import { login } from "../components/login/reducers/index";
import {automationResults} from "../components/upgrade-status/reducer/index";
import {automationAnalytics} from "../components/autoation-analytics/reducer/index";
import {automationExecution} from "../components/execuation-dashboard/reducer/index";
import {quintessential} from "../components/quintessential/reducer/index";
import {activeUser} from "../components/activate-user/reducer/index";
import {customer} from "../components/customer/reducer/index";
import {salesForce} from "../components/salesforce-login/reducer/index";
// import { password } from 'modules/password/reducers/index';
// import { signUp } from 'modules/signup/reducers';
// import { signUp } from '../components/main/reducers';
// import { dashboard } from 'modules/dashboard/reducers';


const persistConfig = {
  key: 'authData',
  storage: storage
};

const rootReducer = (history) =>
  combineReducers({
    apiCalls,
    signUp,
    login,
    form: formReducer,
    router: connectRouter(history),
    auth: persistReducer(persistConfig, authReducer),
    automationResults,
    chart,
    quintessential,
    toastr: toastrReducer,
    automationAnalytics,
    activeUser,
    automationExecution,
    customer,
    salesForce
    });

export default rootReducer;
